import { render } from "./EditOnTrade.vue?vue&type=template&id=1a652914&scoped=true"
import script from "./EditOnTrade.vue?vue&type=script&lang=js"
export * from "./EditOnTrade.vue?vue&type=script&lang=js"

import "./EditOnTrade.vue?vue&type=style&index=0&id=1a652914&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a652914"]])

export default __exports__